// import hooks
// import { useState } from "react";
import { useTranslation } from "react-i18next";
import useWindowSize from "../../utils/custom-hooks/useWindowSize";

// import components
import { Container, Row, Col } from "react-bootstrap";
import RoutPath from "../RoutPath";
import Avatar from "./Avatar";
import AccountList from "./AccountList";

// import assets
import "../../assets/css/account.css";
import avatar from "../../assets/img/client1.png";
import CartSummary from "../Cart/CartSummary";
import Order from "./Order";

// import data
import { summary } from "../../utils/data/cartData";

const OrderSummary = ({ name, items, order }) => {
    // const [name, setName] = useState("mido");

    const [t] = useTranslation("global");
    const windowWidth = useWindowSize();
    return (
        <section className="ocean-section wishlist-section">
            <Container>
                <Row>
                    <RoutPath />
                </Row>
                <Row>
                    {windowWidth >= 992 && (
                        <Col lg={3}>
                            <Avatar
                                avatar={avatar}
                                name={name}
                                points={120}
                                lgClass="lg-side-account-list"
                            />
                            <AccountList />
                        </Col>
                    )}
                    <Col lg={9}>
                        <h1 className="ocean-h1">
                            {t("account.order.order-details")}
                        </h1>
                        <Row>
                            <Col md={7}>
                                {items.map((i) => (
                                    <Order item={i} />
                                    // <></>
                                ))}
                            </Col>
                            <Col md={5}>
                                <div className="order-item product-section-div lg-font-70perc">
                                    <p className="order-title ocean-p-700">
                                        {t("account.order.order-details")}
                                    </p>

                                    <p className="order-status-p flex-start-row ocean-p-700">
                                        <span className="order-status-txt">
                                            {t("account.order.order-status")}
                                        </span>
                                        <span
                                            className={`order-status-status ${
                                                order.details.condition == 1
                                                    ? "green-txt"
                                                    : "red-txt"
                                            }`}
                                        >
                                            {order.details.condition == 1
                                                ? t("account.order.complete")
                                                : t("account.order.uncomplete")}
                                        </span>
                                    </p>

                                    <p className="order-item-paymethod ocean-p-700">
                                        {t("account.order.pay-method")}{" "}
                                        {order.details.payMethod}
                                    </p>

                                    <p className="ocean-p-700 ocean-p-grey">{`${t(
                                        "account.order.date"
                                    )} ${order.details.time} ${
                                        order.details.date
                                    }`}</p>
                                </div>

                                <div className="lg-font-70perc">
                                    <CartSummary summary={summary} />
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default OrderSummary;
